export const emailRegex = /^[A-Za-z0-9]{1}[A-Za-z0-9+_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
export const phoneRegex = /^0{1}\d{8,13}$/;
export const passwordRegexp = /^[a-zA-Z\d!"#$%&'()*+\-.,\/:;<=>?@\[\\\]^_`{|}~]{8,56}$/i;
